/**
 * Stored in slidetypelines (STAutoEntry* / STAutoExit*) and objgrouplines (OGAuto*).
 * Empty value is treated as null (no timeline link).
 */
export const TIMELINE_MARKER_OPTIONS: { label: string; value: string }[] = [
  { label: '—', value: '' },
  { label: 'PREVLINE (previous line sr no)', value: 'PREVLINE' },
  { label: 'FIRSTGROUPLINE (first line in this group instance)', value: 'FIRSTGROUPLINE' },
  { label: 'LASTGROUPLINE (last line in this group instance)', value: 'LASTGROUPLINE' },
  { label: 'ELEMBEFORE', value: 'ELEMBEFORE' },
  { label: 'ELEMAFTER', value: 'ELEMAFTER' },
  { label: 'OGBEFORE', value: 'OGBEFORE' },
  { label: 'OGAFTER', value: 'OGAFTER' },
];

/** Values for HTML datalist on creator slide lines (PSLShow* / PSLExit* directives). Free text allowed, max 100 chars in DB. */
export const TIMELINE_DIRECTIVE_DATLIST_VALUES: string[] = [
  'PREVLINE',
  'FIRSTGROUPLINE',
  'LASTGROUPLINE',
  'LASTGORUPLINE',
  'ELEMBEFORE',
  'ELEMAFTER',
  'OGBEFORE',
  'OGAFTER',
];

/** Short hint under timeline columns in creator */
export const TIMELINE_DIRECTIVE_FIELD_HELP =
  'Directives only — resolved when building PPT transfer. Use markers or creator refs like LINE#12 (line PSLSrNo). Max 100 characters.';
